<div class="hidden md:flex z-[1] absolute top-0 left-0 overflow-hidden h-screen w-screen self-center"><img
        class="min-h-[100vh] min-w-[100vw]" style="object-fit: cover;" src="../../assets/login_background.png"></div>
<div class="w-screen h-screen flex place-content-center items-center bg-tertiary absolute top-0 left-0 z-[2] cut-bg"
    *transloco="let t;prefix:'auth'">
    <div class="md:w-[350px] grid pb-[10vh] h-screen">
        <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
            <img class="" [src]="'../assets/logo.png'" />
        </div>
        <div>
               <std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input" customContainerlass="mb-8"
                [label]="t('password')" [placeholder]="t('password')" [(ngModel)]="password" id="password-login"
                [type]="showPassword ? 'text':'password'" [value]="password">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="'Conferma password'" [placeholder]="'Conferma password'" [(ngModel)]="confirmPassword" id="password-login"
                [type]="showPassword ? 'text':'password'" [value]="confirmPassword">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>

           @if(app != '0'){ <div class="flex gap-4 text-medium items-center w-full mt-4"><std-checkbox borderTrue="var(--primary)"
                    backGroundTrue="var(--primary)" [isChecked]="acceptTerms" (onChange)="checkboxTerms($event)" id="referral">
                </std-checkbox>
                <div>Prima di proseguire devi accettare i nostri <a class="font-bold text-primary underline" target="_blank"
                        href="https://www.stdoutsrl.it/privacy-estetistapp/">termini e condizioni</a></div>
            </div>}

            <div (click)="backToLogin()"
                class="text-[#2D2D2D] cursor-pointer w-fit text-[12px] opacity-50 mt-[10px] ml-auto">
                Torna al login</div>
        </div>
        <div class="ml-auto w-full" [ngClass]="{'opacity-30 pointer-events-none': !password || password !== confirmPassword || (app != '0' && acceptTerms == false)}">
            <std-button (click)="changePassword()" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">Cambia password</std-button>
        </div>
    </div>
</div>